import React from "react";
import "./Manufacture.css";

function Manufacture() {
  return (
    <div className="table-container">
      {/* Column 1 */}
      <div className="table-column">
        <h2>Value stream layout</h2>
        <ol>
          <li>
            Process flow arranged by value streams
            <ul>
              <li>PDC higher tonnage</li>
              <li>PDC lower tonnage</li>
              <li>GDC</li>
            </ul>
          </li>
          <li>
            Linear process from Raw material loading to final part dispatch
          </li>
          <li>
            Culmination of <b>Melting, Core making, Casting, Fettling, Shot blasting, Heat treatment</b> and <b>Machining</b> under one roof
          </li>
          <li>
            Equipped with <b>ASRS</b> and <b>AMR</b> for systematic part handling and storage
          </li>
        </ol>
      </div>

      {/* Column 2 */}
      <div className="table-column">
        <h2>Plant capability</h2>
        <ol>
          <li>Fully connected plant with private 5G network for faster data transmission</li>
          <li>Capacity highlight includes 8 tower furnaces, 46 robots for core operations, 320 CNC machines and 22 shot blasting machines</li>
          <li>Heat treatment capability includes T4, T6 and T7 process</li>
          <li>In-house core making facility</li>
        </ol>
      </div>

      {/* Column 3 */}
      <div className="table-column">
        <h2>Product capability</h2>
        <ol>
          <li>Co-creation of product design</li>
          <li>Strong R&D team working for light weighting and alternate alloys with design centres at Europe</li>
          <li>Network with external research centres (IIT-Madras)</li>
          <li>Die design competency</li>
        </ol>
      </div>
    </div>
  );
}

export default Manufacture;
